import instance from "../apis/axiosConfig";

// CREATE
export const createPdf = (data) =>
  instance.post("/pdfUpload/create", data);

// GET WITH PAGINATION
export const getPdf = (page, limit) =>
  instance.get(`/pdfUpload/all?page=${page}&limit=${limit}`);

// UPDATE TITLE
export const updatePdf = (id, data) =>
  instance.post(`/pdfUpload/update/${id}`, data);

// DELETE
export const deletePdf = (id) =>
  instance.delete(`/pdfUpload/delete/${id}`);

// UPDATE IMAGE
export const updatePdfImage = (id, data) =>
  instance.post(`/pdfUpload/update-image/${id}`, data);

// UPDATE PRIORITY
export const updatePdfPriority = (data) =>
  instance.post(`/pdfUpload/priority`, data);